import React from 'react'
import DescriptionIcon from '@material-ui/icons/Description';
import { blue, green, red } from '@material-ui/core/colors';
import RouterIcon from '@material-ui/icons/Router';
import RegularButton from 'components/CustomButtons/Button';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useDispatch, useSelector } from 'react-redux';
import { removeXlsxRow } from 'redux/actions/xlsx/xlsxActions';
import WarningIcon from '@material-ui/icons/Warning';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Typography } from '@material-ui/core'
import { FolderZip } from '@mui/icons-material';
import { PROYECT } from "services/api"
import { safeRemoveChild } from "helpers/safeRemoveChild";

export const columns = [
  {
    Header: 'Nombre Archivo',
    accessor: 'fileName',
    filterable: true,
    filterMethod: (filter, row) =>
      row.fileName.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Entradas',
    accessor: 'totalReceptions',
    filterable: true,
    filterMethod: (filter, row) =>
      row.totalReceptions.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Salidas",
    accessor: "departures",
    filterable: true,
    filterMethod: (filter, row) =>
      row.departures.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Inventario",
    accessor: "stock",
    filterable: true,
    filterMethod: (filter, row) =>
      row.stock.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "# Permiso",
    accessor: "pNumber",
    filterable: true,
    filterMethod: (filter, row) =>
      row.pNumber.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Mes",
    accessor: "month",
    filterable: true,
    filterMethod: (filter, row) =>
      row.month.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => <div style={{ textAlign: 'center' }}>{original.month}</div>
  },
  {
    Header: "Año",
    accessor: "year",
    filterable: true,
    filterMethod: (filter, row) =>
      row.year.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => <div style={{ textAlign: 'center' }}>{original.year}</div>
  },
  {
    Header: "Archivo",
    Cell: ({ original }) => <div style={{ textAlign: 'center' }}>{original?.validFile ? <DescriptionIcon style={{ color: blue[500] }} /> : original?.errorMessage ? 
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      gap: 8,
      alignItems: 'center',
      flexDirection: 'column'
    }}>
      <WarningIcon style={{ color: red[500] }} />
      <Typography variant="caption" style={{ color: red[500] }}>{original.errorMessage}</Typography>
    </div> : <WarningIcon style={{ color: red[500] }} />
    }</div>
  },
  {
    Header: "Log Status",
    Cell: ({ original }) => {
      const iconStyle = {
        textAlign: 'center',
        color: original?.validFile ? (original?.url ? green[500] : blue[500]) : red[500]
      };

      const IconComponent = original?.validFile ? RouterIcon : WarningIcon;

      return (
        <div style={iconStyle}>
          <IconComponent />
        </div>
      );
    }
  },
  {
    Header: "Acciones",
    Cell: ({ original }) => {
      const { token } = useSelector((state) => state.login);
      const dispatch = useDispatch()
      const handleRemove = () => {
        dispatch(removeXlsxRow(original.id))
      }

      const handleDownload = async ( type = 'xml' ) => {
        try {
          const downloadUrl = type === 'xml' ? original.url : `${process.env.REACT_APP_URL}${PROYECT}/xml_volumetrics/zip?url=${original.url}`
          const options = {
            headers: { Authorization: token },
            responseType: 'blob'
          }
          const response = await fetch(downloadUrl, options);
          const blob = await response.blob();
          const split = original.url.split('/');
          let name = split[split.length - 1];
          name = name.slice(0, name.length - 4);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${name}.${type}`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          safeRemoveChild(a);
        } catch (error) {
          console.error('Error al descargar el archivo:', error);
        }
      };


      return (
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 8
        }}>
          <RegularButton
            justIcon
            round
            tooltip="Eliminar"
            color="transparent"
            onClick={handleRemove}
          >
            <DeleteForeverIcon style={{ color: red[500], margin: 0 }} />
          </RegularButton>
          {original.url && (
            <>
              <RegularButton
                justIcon
                round
                tooltip="Descargar XML"
                color="transparent"
                onClick={() => handleDownload('xml')}
              >
                <GetAppIcon style={{ color: green[500], margin: 0 }} />
              </RegularButton>
              <RegularButton
                justIcon
                round
                tooltip="Descargar ZIP"
                color="transparent"
                onClick={() => handleDownload('zip')}
              >
                <FolderZip style={{ color: green[500], margin: 0 }} />
              </RegularButton>
            </>
          )}
        </div>
      )
    }
  },

]